export const FAILED = 1
export const NOT_TESTED = 2
export const SUCCESS = 3
